// extracted by mini-css-extract-plugin
export var marquee = "Marquee-module--marquee--3lGVT";
export var marquee__content = "Marquee-module--marquee__content--wYuG8";
export var enableanimation = "Marquee-module--enableanimation--20Eh4";
export var scroll = "Marquee-module--scroll--2dlyt";
export var marqueeFitContent = "Marquee-module--marquee--fit-content--HfxRh";
export var marqueePosAbsolute = "Marquee-module--marquee--pos-absolute--2MQf5";
export var scrollAbs = "Marquee-module--scroll-abs--15p44";